import {
  FETCH_STATISTICS_FAILED,
  FETCH_STATISTICS,
  FETCH_STATISTICS_SUCCESS,
  StaticsState,
  StatiscsActions,
} from './types';

const initialState: StaticsState = {
  loading: false,
  error: undefined,
  entities: undefined,
  result: undefined,
};

const reducer = (
  state = initialState,
  action: StatiscsActions
): StaticsState => {
  switch (action.type) {
    case FETCH_STATISTICS:
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case FETCH_STATISTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        ...action.payload,
      };
    case FETCH_STATISTICS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload?.error,
      };
  }
  return state;
};

export default reducer;
